/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UriMatching } from './UriMatching';

export type AssetSelectionDto = {
    assetSelectionConfiguration?: UriMatching;
    assetType: AssetSelectionDto.assetType;
    children: Array<AssetSelectionDto>;
    id: string;
    included?: boolean;
    name: string;
    newChildrenIncluded?: boolean;
};

export namespace AssetSelectionDto {

    export enum assetType {
        ACCOUNT = 'ACCOUNT',
        ENVIRONMENT = 'ENVIRONMENT',
        RESOURCE_GROUP = 'RESOURCE_GROUP',
        DATA_FACTORY = 'DATA_FACTORY',
        DATABASE = 'DATABASE',
        SCHEMA = 'SCHEMA',
        PROJECT = 'PROJECT',
        DATASET = 'DATASET',
        CLUSTER = 'CLUSTER',
        CATALOG = 'CATALOG',
        WORKSPACE = 'WORKSPACE',
        SPACE = 'SPACE',
        FOLDER = 'FOLDER',
        CONNECTION = 'CONNECTION',
    }


}
